'use client';

import { useEffect } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { logClientError } from 'src/lib/logger.client';

/**
 * Globalni error boundary za cijelu aplikaciju.
 * Hvata sve neobrađene errore u Server Components i Client Components.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logClientError(error, {
      context: 'global-error-boundary',
      digest: error.digest,
    });
  }, [error]);

  return (
    <html lang="bs">
      <body>
        <Container maxWidth="sm">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '100vh',
              gap: 2,
              textAlign: 'center',
            }}
          >
            <Typography variant="h3" color="error">
              Došlo je do greške
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {error.message || 'Neočekivana greška u aplikaciji.'}
            </Typography>
            {error.digest && (
              <Typography variant="caption" color="text.disabled">
                Error ID: {error.digest}
              </Typography>
            )}
            <Button variant="contained" onClick={reset} sx={{ mt: 2 }}>
              Pokušaj ponovo
            </Button>
          </Box>
        </Container>
      </body>
    </html>
  );
}
